import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
 import { Testimonials } from "../components/testimonials";
import { Team } from "../components/Team";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";

import { Footer } from "../components/footer";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Start = () => {
  //https://react-landing-page-template-93ne.vercel.app/
  //https://github.com/issaafalkattan/React-Landing-Page-Template

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />

      <Header data={landingPageData.Header} />
      

      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      
      {
        // <Features data={landingPageData.Features} />
       //   <Testimonials data={landingPageData.Testimonials} />
      }
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
      <Footer />
    </div>
  );
};

export default Start;
